export const version = 'kunde-v1.20.0-SNAPSHOT-4bf367f97998c92a0f5b312ae2a9faba971ac49b';